import Vue from "vue";
import allMixins from './mixins.js';
import Router from "vue-router";
import LogIn from "./views/auth/Login.vue";
import ErrorPage from "./views/404.vue";

Vue.use(allMixins);
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  linkExactActiveClass: "nav-active",
  routes: [  
    { name:"login", path: "/login", component: LogIn, meta: { title: 'Login'},
      beforeEnter(to, from, next) {
        let userToken = allMixins.methods.retrieveToken(window.btoa('userToken'))
        if (userToken === null) {
          // console.log("not logged in");
          next();
        } 
        else {
          next('/home');
        }
      }
    },
    { path: "/", redirect: "/login" },
    { name:"signup", path: "/signup", component: () => import("./views/auth/Signup.vue"), meta: {title: 'Sign Up'} },
    { name:"admin signup", path: "/admin-signup", component: () => import("./views/auth/AdminSignup.vue"), meta: {title: 'Complete Profile'} },
    {path: "/reset/password/:cipher", component: () => import("./views/auth/ResetPassword.vue"), meta: {title: 'Reset Password'} },
    {path: "/users/verify/email/:cipher", component: () => import("./views/auth/Verification.vue"), meta: {title: 'Verify Email'} },
    
    //specify a before route enter for login, to check if user is logged in on the device already
    
    // General
    { name:"home", path: "/home", component: () => import("./views/Home.vue"), meta: { title: 'Home', reqToken: true}, props: true,
      beforeEnter(to, from, next) {
        let userToken = allMixins.methods.retrieveToken(window.btoa('userToken'))
          let details = Vue.$jwt.decode(userToken, "inGXVHWPU9BB5q2oix1r-zaA")
          if(details == null) {
            localStorage.clear()
            next('/')
          }
          else {
              next()
          }
    }
    },
    //Admin Section, 
    {
      path: "",
      component: () => import("./views/Admin.vue"),
      children: [
        { path: '/admin', redirect: '/admin/dashboard'},
        { name:"dashboard", path: "/admin/dashboard", component: () => import("./views/admin/Dashboard.vue"), meta: {title: 'Dashboard', reqToken: true} },
        { name:"users", path: "/admin/users", component: () => import("./views/admin/Users.vue"), meta: {title: 'Users', reqToken: true} },
        { path: "/admin/volunteers", component: () => import("./views/admin/Volunteers.vue"), meta: {title: 'Volunteers', reqToken: true} },
        { path: "/admin/trainings", component: () => import("./views/admin/Trainings.vue"), meta: {title: 'Listener Trainings', reqToken: true} },
        { path: "/admin/trainings/:id", component: () => import("./views/admin/ViewTraining.vue"), meta: {title: 'Listener Training', reqToken: true} },
        { path: "/admin/trainings/:id/edit", component: () => import("./views/admin/EditTraining.vue"), meta: {title: 'Edit Training', reqToken: true} },
        { path: "/admin/extras", component: () => import("./views/admin/Extras.vue"), meta: {title: 'Others', reqToken: true} },
        { path: "/admin/clubs", component: () => import("./views/admin/Clubs.vue"), meta: {title: 'Campus Clubs', reqToken: true} },
        { path: "/admin/team-members", component: () => import("./views/admin/Team.vue"), meta: {title: 'Team Members', reqToken: true} },
        { path: "/admin/events", component: () => import("./views/admin/Events.vue"), meta: {title: 'Events', reqToken: true} }
      ],
      beforeEnter(to, from, next) {
        let userToken = allMixins.methods.retrieveToken(window.btoa('userToken'))
            let details = Vue.$jwt.decode(userToken, "inGXVHWPU9BB5q2oix1r-zaA")
            if(details == null) {
              localStorage.clear()
              next('/')
            }
            else {
              if (details.userRoles.includes('admin_member') | details.userRoles.includes('superadmin'))
              {
                next()
              }
              else{
                next('/')
              }
            }
      }
    },
    // Listeners section
    {
      path: "",
      component: () => import("./views/Listener.vue"),
      children: [
        { name:"dashboardListener", path: "/listener/dashboard", component: () => import("./views/listener/Dashboard.vue"), meta: {title: 'Dashboard', reqToken: true} },
        { name:"profileListener", path: "/listener/profile", component: () => import("./views/listener/Profile.vue"),  meta: {title: 'Profile', reqToken: true} },
        { name:"editListener", path: "/listener/edit-profile", component: () => import("./views/listener/EditProfile.vue"),  meta: {title: 'Edit Profile', reqToken: true} },
        { name:"chatListener", path: "/listener/chat", component: () => import("./views/listener/Chat.vue"),  meta: {title: 'Chat Room', reqToken: true} },
        { path: "/listener/certifications", component: () => import("./views/listener/Certifications.vue"),  meta: {title: 'Certifications', reqToken: true} },
        { path: "/listener/trainings", component: () => import("./views/listener/AllTrainings.vue"), meta: {title: 'Trainings', reqToken: true} },
        { path: "/listener/training/:id", component: () => import("./views/listener/SingleTraining.vue"), meta: {title: 'Training', reqToken: true} },
        { name:"trainingTest", path: "/listener/test/:payload", component: () => import("./views/listener/Test.vue"), meta: {title: 'Training Test', reqToken: true}, props: true },
      ],
      beforeEnter(to, from, next) {
        let userToken = allMixins.methods.retrieveToken(window.btoa('userToken'))
          let details = Vue.$jwt.decode(userToken, "inGXVHWPU9BB5q2oix1r-zaA")
          if(details == null) {
            localStorage.clear()
            next('/')
          }
          else {
            if (details.userRoles.includes('listener'))
            {
              next()
            }
            else{
              next('/')
            }
          }
      }
    },
    // Members/Helpseekers section
    {
      path: "",
      component: () => import("./views/Member.vue"),
      children: [
        { name:"dashboardMember", path: "/dashboard", component: () => import("./views/member/Dashboard.vue"), meta: {title: 'Dashboard', reqToken: true} },
        { name:"profileMember", path: "/profile", component: () => import("./views/member/Profile.vue"),  meta: {title: 'Profile', reqToken: true} },
        { name:"editMember", path: "/edit-profile", component: () => import("./views/member/EditProfile.vue"),  meta: {title: 'Edit Profile', reqToken: true} },
        { name:"chatMember", path: "/chat", component: () => import("./views/member/Chat.vue"),  meta: {title: 'Chat Room', reqToken: true} },
        { path: "/listeners", component: () => import("./views/member/Listeners.vue"), meta: {title: 'Listeners', reqToken: true} },
      ],
      beforeEnter(to, from, next) {
        let userToken = allMixins.methods.retrieveToken(window.btoa('userToken'))
          let details = Vue.$jwt.decode(userToken, "inGXVHWPU9BB5q2oix1r-zaA")
          if(details == null) {
            localStorage.clear()
            next('/')
          }
          else {
            if (details.userRoles.includes('helpseeker'))
            {
              next()
            }
            else{
              next('/')
            }
          }
      }
    },  
    { path: '/error', component: ErrorPage, meta: { title: 'Page Not Found'}},
    { path: "*", redirect: '/error'}
  ]
});

const DEFAULT_TITLE = 'Fitila';
router.afterEach((to, from) => {
    document.title = `${to.meta.title} | ${DEFAULT_TITLE}`;
});

export default router;
